<template>
  <div class="media-data">
    <a-button class="add-btn" type="primary" @click="addClick" v-if="userInfo.innerFlag === 1">新增</a-button>
    <a-input-search class="input-search" v-model="searchKeyWord" placeholder="请输入显示名称、字段名称或说明" @search="search" />
		<div class="frequency-prompt" v-if="syncFrequency">{{syncFrequency}}</div>
		<div class="page-table">
      <vxe-grid
        border="inner"
        :columns="columns"
        auto-resize
        :column-config="{resizable: true}"
        :row-config="{isCurrent: true, isHover: true}"
        id="id"
        :data="data"
        show-overflow
        :empty-render="{name: 'NotData'}"
        size="small"
        :loading="loading"
      >
        <template  #handle="{row}">
					<div class="table-handle-btn">
            <template v-if="row.isDynamic&&row.own">
              <a-tooltip placement="top" title="编辑">
                <icon-font class="edit-btn" type="icon-Edit" @click="editClick(row)"/>
              </a-tooltip>
              <a-popconfirm
                title="是否确认删除？"
                ok-text="确定"
                cancel-text="取消"
                @confirm="deleteClick(row)"
              >
                <a-tooltip placement="top" title="删除">
                  <icon-font class="delete-btn" type="icon-Delete"/>
                </a-tooltip>
              </a-popconfirm>
            </template>
          </div>
        </template>
        <template #name="{row}">
          <div :style="{
            paddingRight: row.isDynamic?'58px':'0px',
            position: 'relative',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline-block',
            verticalAlign: 'bottom'
          }">
            <span>{{row.name}}</span><a-tag v-if="row.isDynamic" class="define-tag" color="#F1F7FF">自定义</a-tag>
          </div>
        </template>
        <template #dataType="{row}">
          <span>{{ $enum.DATA_TYPE[row.dataType] }}</span>
        </template>
        <template  #symbol="{row}">
          <span>{{ row.fieldUnit&&row.fieldUnit.symbol?row.fieldUnit.symbol:'-' }}</span>
        </template>
        <template  #tableIds="{row}">
          <span>{{ transTableIds(row.tableIds) }}</span>
        </template>
      </vxe-grid>
      <a-pagination
        class="mt-16 mb-16 df-end"
        size="small"
        v-if="(data &&data.length > 0)"
        :pageSize="pagination.pageSize"
        :total="pagination.total"
        :current="pagination.current"
        @change="(page, pageSize) => handleTableChange(page,pageSize)"
      />
    </div>
    <addFieldsModal ref="addModal" :code="code" @success="pagination.current = 1,getList()"></addFieldsModal>
  </div>
</template>
<script>
import { findFieldsByCode, deleteField, getFrequency, findRecordsetByCode } from "@/api/mediadata"
import addFieldsModal from "./addFieldsModal"
import { mapState } from "vuex"

const columns = [
  { type: 'seq', title: '序号',width: 60 },
	{
		title: '显示名称',
		field: 'name',
		align: 'left',
    ellipsis: true,
    slots: { default: 'name' },
		// width: 180,
	},
  {
		title: '单位',
		field: 'symbol',
		align: 'left',
		width: 80,
    slots: { default: 'symbol' },
	},
  {
		title: '数据集',
		field: 'tableIds',
		align: 'left',
    slots: { default: 'tableIds' },
	},
  {
    title: '说明',
    field: 'desc',
    align: 'left',
    ellipsis: true,
    // width: 300,
  },
	{
		title: '字段名称',
		field: 'field',
		align: 'left',
    ellipsis: true,
		// width: 220,
	},
  {
    title: '字段类型',
    field: 'dataType',
    align: 'left',
    width: 100,
    slots: { default: 'dataType' }
  },
  {
		title: '操作',
		field: 'handle',
		align: 'left',
		slots: { default: 'handle' },
		width: 100,
	},
]
export default {
	name: 'MediaData',
	data() {
		return {
			loading: false,
      searchKeyWord: '',
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10,
        showTotal: total => `共${total}条`
			},
			data: [],
			columns,
      syncFrequency: '',
      tableList: [],
		}
	},
  props: ['code'],
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
  },
  methods: {
    transTableIds(ids) {
      return ids.map(v => {
        let obj = this.tableList.find(val => val.id == v) || ''
        return obj.name || v
      }).join()
    },
    addClick() {
      this.$refs.addModal.init()
    },
    editClick(record) {
      this.$refs.addModal.init(record)
    },
    search(value) {
      this.pagination.current = 1
      this.getList()
    },
    getList() {
      this.loading = true
      findFieldsByCode({
        params: {
          code: this.code
        },
        data: {
          pageSize: this.pagination.pageSize,
          pageNo: this.pagination.current,
          searchKeyWord: this.searchKeyWord
        }
      }).then((res) => {
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    getFrequency() {
			getFrequency({
				mediaCode: this.code
			}).then((res) => {
        this.syncFrequency = res.data?.updatePoint || ''
        this.$emit('updatePoint', res.data?.frequency || '')
			})
		},
    handleTableChange(page) {
      const pager = { ...this.pagination, current:page };
			this.pagination = pager;
			this.getList()
		},
    // 删除自定义字段
		deleteClick(record) {
      deleteField(record.id).then((res) => {
        let code = res.code
        if(code === 500100) {
          this.$error({
            width: 640,
            title: "删除失败",
            content: h => <p class="error-message">{ res.msg }</p>,
            okText: '确定'
          });
        } else {
          this.$message.success('删除成功！')
          if(this.data.length === 1) {
            this.pagination.current = 1
          }
          this.getList()
        }
      })
		},
    async getTableList() {
      await findRecordsetByCode({
        code: this.code
      }).then((res) => {
        this.tableList = res.data || []
      })
    },
  },
  async mounted() {
    console.log(this.userInfo)
    await this.getTableList()
    this.getList()
		this.getFrequency()
  },
  components: {
    addFieldsModal
  }
}
</script>
<style lang="less" scoped>
.media-data {
  position: relative;
  .frequency-prompt {
		padding-left: 20px;
		padding-bottom: 10px;
	}
  .input-search {
    width: 258px;
    top: -53px;
    position: absolute;
    right: 106px;
    color: #9CA9CB;
  }
  .add-btn {
    position: absolute;
    top: -53px;
    right: 24px;
  }
  .edit-btn {
		margin-right: 16px;
	}
	.delete-btn,.copy-btn, .edit-btn {
		cursor: pointer;
		font-size: 16px;
		vertical-align: middle;
	}
  .define-tag {
    color: #2A6CED;
    transform: scale(0.7, 0.7);
    vertical-align: top;
    position: absolute;
    right: 0;
    top: -3px;
    margin-right: 0;
  }
}
</style>
<style lang="less">
  .error-message {
    white-space: pre-line;
    font-size: 14px;
    font-weight: 400;
    color: #2D3446;
    line-height: 22px;
  }
</style>